import { CornerDotTypes } from "../types";

export default {
  dot: "dot",
  square: "square",
  hexagon: "hexagon",
  octagon: "octagon",
  teardrop: "teardrop",
  star: "star"
} as CornerDotTypes;
